import { showUnfinished } from './site-config';

/**
 * Same gate as app.module's isDevOnly: dev2 and local dev builds only (see
 * site-config). Always false on staging and production, so shared components
 * can switch to dev2-only systems (Saved plates v2, Track plate) without
 * changing what the release does.
 */
export const isDevOnly: boolean = showUnfinished;
